<template lang="pug">
.all-locations
	h1 {{ pageTitle }}
	Loader(v-if="!loaded")
	span(v-else)
		LinkList
		.states-container
			StateContainer(
				v-for="(array, state) in locations", 
				:key="state", 
				:stateName="state", 
				:locationArray="array",
				v-if="currentView == 'all' || currentView == state"
			)
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

import Loader from "../locationsListing/components/Loader";
import LinkList from "./components/LinkList";
import StateContainer from "./components/StateContainer";


export default {
	components: {
		// TransitionFade,
		Loader,
		LinkList,
		StateContainer,
	},
	data() {
		return {
			loaded: false,
		};
	},
	computed: {
		...mapGetters([
			"pageTitle",
			"currentView",
			"locations",
		]),
	},
	methods: {
		...mapMutations([]),
		...mapActions([
			"getStateData"
		]),
	},
	created() {
		setTimeout(() => (this.loaded = true), 500);
	},
	async mounted() {
		await this.getStateData(this.$root.apiEndpoint);
		this.loaded = true;
	}
};
</script>


<style scoped lang="scss">

</style>